import React from 'react';

export default function AppFooter() {
	return (
		<footer className="footer">
			<div className="container-fluid">
				<div className="row">
					<div className="col-sm-12">
						© {new Date().getFullYear()} {I18n.t('admin.footer')}
					</div>
				</div>
			</div>
		</footer>
	);
}
